// 認証モーダル
const ModalPropertyBulkDelete = {
  namespaced: true,

  state: {
    modal: false,
  },
  getters: {
    getModal: state => {
      return state.modal
    },
  },
  mutations: {
    setModal(state, modal) {
      state.modal = modal
    },
  },
  actions: {},
}

export default ModalPropertyBulkDelete
